<template>
  <div class="w100m">
    <div class="w100 flexVC pR" v-if="$store.state.isPc">
      <div style="height: 100px;"></div>
      <div style="width: 320px;height: 90px;" class="pR flexVC">
        <div class="title">趁早读书会</div>
        <div class="w100 pR title-line-box">
          <div class="titleLine"></div>
          <div class="titleLine-animation"
               :class="isShow ? 'titleLine-animation-index' : '' "></div>
        </div>
      </div>
      <div class="content ">
        <div class="flexRound">
          <div class="flexVC">
            <img src="../../assets/images/icon_study_group_1.png" class="association-img">
            <div class="association-title marT15">找到同类群体</div>
          </div>
          <div class="flexVC">
            <img src="../../assets/images/icon_study_group_2.png" class="association-img">
            <div class="association-title marT15">建立思维结构</div>
          </div>
          <div class="flexVC">
            <img src="../../assets/images/icon_study_group_3.png" class="association-img">
            <div class="association-title marT15">分享目标与计划</div>
          </div>
          <div class="flexVC">
            <img src="../../assets/images/icon_study_group_4.png" class="association-img">
            <div class="association-title marT15">探讨方向和方法</div>
          </div>
        </div>
        <div class="introduce-box flexHC">
          <div class="introduce-text-box flexHC2">
            <div class="introduce-text">{{content}}</div>
          </div>
          <el-image
            class="read-img"
            :src="readImg"
            :fit="cover"></el-image>
        </div>
      </div>
      <div style="width: 85%;margin-top: 100px;" class="flexVC2">
        <!--      <div class="nav-city-bar-item" style="min-width: 50px;">全部</div>-->
        <div class="flexRound">
          <div class="nav-city-bar-item" v-for="item in cityData" @click="navChange(item.type)"
               :class="currentType == item.type ? 'BD70050-nav' : 'BFFF-nav'">{{item.title}}
          </div>
        </div>
        <!--      <div class="nav-city-bar-item"  style="min-width: 80px;">华南区</div>-->
      </div>
      <div class="w100 flexVC">
        <div class="line"></div>
      </div>
      <div class="flexWrap" style="width: 85%;">
        <div class="city-item marT32" v-for="(item,index) in associationReadData"
             v-if="item.type == currentType || currentType == 0"
             :class="index == 0 ? 'marL20' :'marL20'" @mouseenter="moreEnter(index)"
             @mouseleave="moreLeave(index)">
          <div class="city-item-img pR">
            <el-image
              class="city-item-img "
              :src="item.coverUrl"
              :fit="cover"></el-image>
            <div class="city-item-code flexVC2" v-if="item.isShow">
              <div class="code-box flexVC2">
                <el-image
                  class="code-img "
                  :src="item.code"
                  :fit="cover"></el-image>
                <div class="code-text fontE1 marT10">对接人：{{item.nickname}}</div>
              </div>
            </div>
          </div>
          <div class="flexVC2 city-item-content">
            <div>微博：{{item.weibo || '暂无'}}</div>
            <div>微信公众号：{{item.weixin || '暂无'}}</div>
          </div>
        </div>
        <div class="city-item-empty marL20" v-for="count in 6"></div>
      </div>
      <shape-footer></shape-footer>
    </div>
    <!--  移动端  -->
    <div class="w100m flexVC pR Bf0f2f5" v-if="!$store.state.isPc">
      <div style="height: 100px;"></div>
      <div style="width: 2.1rem;height: 0.6rem;" class="pR flexVC">
        <div class="title-m">趁早读书会</div>
        <div class="w100 pR title-line-box-m">
          <div class="titleLine-m"></div>
          <div class="titleLine-animation-m"
               :class="isShow ? 'titleLine-animation-index-m' : '' "></div>
        </div>
      </div>
      <div class="content-m flexHC2" style="margin-top: 0.4rem;">{{content}}</div>
      <div class="w100m "  style="width: 6.54rem">
        <div class="flexRound" style="margin-top: 0.48rem;">
          <div class="flexVC">
            <img src="../../assets/images/icon_study_group_1.png" class="association-img-m">
            <div class="association-title-m marT15">找到同类群体</div>
          </div>
          <div class="flexVC">
            <img src="../../assets/images/icon_study_group_2.png" class="association-img-m">
            <div class="association-title-m marT15">建立思维结构</div>
          </div>
        </div>
        <div class="flexRound" style="margin-top: 0.48rem;">
          <div class="flexVC">
            <img src="../../assets/images/icon_study_group_3.png" class="association-img-m">
            <div class="association-title-m marT15">分享目标与计划</div>
          </div>
          <div class="flexVC">
            <img src="../../assets/images/icon_study_group_4.png" class="association-img-m">
            <div class="association-title-m marT15">探讨方向和方法</div>
          </div>
        </div>
        <div class="w100m flexVC" style="margin-top: 0.48rem;">
          <el-image
            class="read-img-m"
            :src="readImg"
            :fit="cover"></el-image>
        </div>
      </div>
      <div style="width: 100%;margin-top: 1rem;margin-bottom: 0.5rem;" class="flexVC2">
        <!--      <div class="nav-city-bar-item" style="min-width: 50px;">全部</div>-->
        <div class="flexWrap2">
          <div class="nav-city-bar-item-m" v-for="item in cityData" @click="navChange(item.type)"
               :class="currentType == item.type ? 'BD70050-nav' : 'Bf0f2f5-nav'">{{item.title}}
          </div>
        </div>
        <!--      <div class="nav-city-bar-item"  style="min-width: 80px;">华南区</div>-->
      </div>
      <div class="item flexHC" v-for="(item,index) in associationReadData"
           v-if="item.type == currentType || currentType == 0" @click="moreClick(index)">
        <el-image
          class="city-item-img-m"
          :src="item.coverUrl"
          :fit="cover"></el-image>
        <div style="margin-left: 0.24rem;">
          <div class="city-item-title-m">{{item.title}}</div>
          <div class="city-item-subtitle-m" style="margin-top: 0.22rem;">微博：{{item.weibo || '暂无'}}
          </div>
          <div class="city-item-subtitle-m" style="margin-top: 0.08rem;">微信公众号：{{item.weixin ||
            '暂无'}}
          </div>
        </div>
      </div>
      <div style="height: 1rem;"></div>
      <code-modal :codeImg="currentCodeData.codeImg" :title="currentCodeData.nickname" :subtitle="currentCodeData.tips"  @closeModal="closeModal" v-show="isShowModal"></code-modal>
      <shape-footer></shape-footer>
    </div>
  </div>
</template>

<script>

  import {associationMotionData, associationReadData} from '@/utils/staticData'
  import shapeFooter from '@/components/ShapeFooter'
  import codeModal from '@/components/CodeModal'

  export default {
    name: "association",
    data() {
      return {
        content: '趁早读书会是由创始人王潇于2014年4月23日世界读书日发起，全球各城市自发申请组建的“趁早”线下交流平台，旨在帮助大家遇见彼此，共同学习与见证，分享提升，做更多有意义的事。',
        isShow: true,
        isShowModal:false,
        cover: 'cover',
        readImg: 'https://czcollege.oss-cn-beijing.aliyuncs.com/official-shape/%E8%AF%BB%E4%B9%A6%E4%BC%9A%E9%85%8D%E5%9B%BE%402x.png',
        associationMotionData: [],
        associationReadData: [],
        currentType: 0,
        currentCodeData: {
          codeImg: '',
          nickname: '',
          tips: '扫码加入读书会',
        },
        cityData: [
          {
            title: '全部',
            type: 0
          },
          {
            title: '华北区',
            type: 1
          }, {
            title: '东北区',
            type: 2
          }, {
            title: '西北区',
            type: 3
          }, {
            title: '华东区',
            type: 4
          }, {
            title: '西南区',
            type: 5
          }, {
            title: '华中区',
            type: 6
          }, {
            title: '华南区',
            type: 7
          },],
      }
    },

    components: {
      shapeFooter,
      codeModal,
    },

    mounted() {
      this.$store.commit('edit', 0)
      this.isShow = true
      this.associationMotionData = associationMotionData
      this.associationReadData = associationReadData
    },

    methods: {
      navChange(type) {
        this.currentType = type
      },
      closeModal(){
        this.isShowModal = false
      },
      moreClick(index, type = 1) {
        if (type == 2) {
          this.currentCodeData.nickname = '对接人：' + this.associationMotionData[index].nickname
          this.currentCodeData.codeImg = '对接人：' + this.associationMotionData[index].code
        } else {
          this.currentCodeData.nickname = '对接人：' +  this.associationReadData[index].nickname
          this.currentCodeData.codeImg =  this.associationReadData[index].code
        }
        this.isShowModal = true
      },
      moreEnter(index, type = 1) {
        if (type == 2) {
          this.associationMotionData[index].isShow = true
        } else {
          this.associationReadData[index].isShow = true
        }
      },
      moreLeave(index, type = 1) {
        if (type == 2) {
          this.associationMotionData[index].isShow = false
        } else {
          this.associationReadData[index].isShow = false
        }
        // console.log('222222222222222222222')
        // this.$refs.more.$el.style.cssText = 'width: 230px;height: 51px;color: #FFFFFF;';
      },
    },

  }
</script>

<style scoped>

  .title {
    width: 320px;
    font-size: 60px;
    font-family: SourceHanSerifCN-Heavy, SourceHanSerifCN;
    font-weight: 800;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    left: 50%;
    margin-left: -160px;
    top: 0;
    z-index: 10;
  }

  .title-line-box {
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0;
  }

  .titleLine {
    width: 100%;
    height: 26px;
    background: #FFCCC0;
  }

  .titleLine-animation {
    width: 100%;
    height: 26px;
    background: #FFFFFF;
    position: absolute;
    top: 0;
    left: 0;
  }


  .content {
    width: calc(100% - 15.1%);
    margin-top: 65px;
  }

  .flexRound {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .association-img {
    width: 92px;
    height: 92px;
  }

  .association-title {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
  }

  .introduce-box {
    width: 100%;
    height: 400px;
    background: #000000;
    margin-top: 55px;
  }

  .introduce-text-box {
    width: 33%;
    height: 100%;
  }

  .introduce-text {
    width: 320px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 27px;
    text-align: justify;
  }

  .read-img {
    width: 67%;
    height: 100%;
  }

  .nav-city-bar-item {
    width: auto;
    height: 55px;
    padding: 0 16px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .BD70050-nav {
    background: #d70050;
    color: #ffffff;
  }

  .BFFF-nav {
    background: #ffffff;
    color: rgba(0, 0, 0, 0.85);
  }

  .Bf0f2f5-nav {
    background: rgba(0, 0, 0, 0.08);
    color: rgba(0, 0, 0, 0.85);
  }

  .line {
    width: 80%;
    height: 1px;
    background: rgba(0, 0, 0, .06);
  }

  .city-item-empty {
    width: 248px;
    height: 248px;
  }

  .city-item {
    width: 248px;
    height: 248px;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.08);
    border-radius: 4px 4px 0px 0px;
    font-size: 12px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.45);
    line-height: 20px;
  }

  .city-item-img {
    width: 100%;
    height: 178px;
  }

  .city-item-code {
    width: 100%;
    height: 178px;
    background: rgba(0, 0, 0, .7);
    position: absolute;
    top: 0;
    left: 0;
  }

  .code-box {
    width: 113px;
    height: 132px;
    background: #FFFFFF;
  }

  .code-text {
    width: 104px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    text-align: center;
  }

  .code-img {
    width: 88px;
    height: 88px;
  }

  .city-item-content {
    width: calc(100% - 15px);
    height: 70px;
    padding-left: 15px;
  }

  .titleLine-animation-index {
    -webkit-animation: spin 0.8s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: spin 0.8s linear 1;
    animation-fill-mode: forwards;
    /*background: #ff0000;*/
  }

  /*定义动画*/
  @-webkit-keyframes spin { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      -webkit-transform: translateX(0px);
    }
    to { /*动画结束状态*/
      -webkit-transform: translateX(300px);
    }
  }

  @keyframes spin {
    from {
      transform: translateX(0px);
    }
    to {
      transform: translateX(300px);
    }
  }

  @media screen and (max-width: 1380px) {
    .bottom {
      width: 100%;
      height: 30.56%;
      position: absolute;
      left: 0;
      bottom: 0;
      background-image: url("../../assets/images/icon_home_second.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

  }


  @media screen and (max-width: 1300px) {

    .introduce-text {
      width: 280px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 27px;
      text-align: justify;
    }

  }


  /**********************************  移动端********************************************/

  .content-m {
    width: 6.54rem;
    font-size: 0.26rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 0.44rem;
    text-align: justify;
  }

  .title-m {
    width: 100%;
    font-size: 0.4rem;
    font-family: SourceHanSerifCN-Heavy, SourceHanSerifCN;
    font-weight: bolder;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    text-align: center;
    left: 0;
    top: 0;
    z-index: 10;
  }

  .title-line-box-m {
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0;
  }

  .titleLine-m {
    width: 100%;
    height: 0.16rem;
    background: #FFCCC0;
  }

  .titleLine-animation-m {
    width: 100%;
    height: 0.16rem;
    background: #f0f2f5;
    position: absolute;
    top: 0;
    left: 0;
  }

  .titleLine-animation-index-m {
    -webkit-animation: spinm 0.8s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: spinm 0.8s linear 1;
    animation-fill-mode: forwards;
    /*background: #ff0000;*/
  }

  .association-img-m {
    width: 0.96rem;
    width: 0.96rem;
  }

  .association-title-m {
    width: 2.4rem;
    font-size: 0.26rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    text-align: center;
  }

  .read-img-m {
    width: 6.54rem;
    height: 3.3rem;
  }

  .nav-city-bar-item-m {
    width: 1.04rem;
    height: 0.48rem;
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 0 0.40rem;
    margin-top: 0.2rem;
  }

  .item {
    width: 6.86rem;
    height: 1.94rem;
    background: #FFFFFF;
    box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.02), 0px 9px 28px 0px rgba(0, 0, 0, 0.03), 0px 6px 16px -8px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    margin-bottom: 0.32rem;
  }

  .city-item-img-m {
    width: 1.46rem;
    height: 1.46rem;
    border-radius: 2px;
    margin-left: 0.24rem;
  }

  .city-item-title-m {
    font-size: 0.32rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }

  .city-item-subtitle-m {
    font-size: 0.22rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
  }

  /*定义动画*/
  @-webkit-keyframes spinm { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      -webkit-transform: translateX(0%);
    }
    to { /*动画结束状态*/
      -webkit-transform: translateX(100%);
    }
  }

  @keyframes spinm {
    from {
      -webkit-transform: translateX(0%);
    }
    to {
      -webkit-transform: translateX(100%);
    }
  }


  .fontE4 {
    display: -webkit-box;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .marT20m {
    margin-top: 0.2rem;
  }

  .marT15m {
    margin-top: 0.15rem;
  }

  .marT10m {
    margin-top: 0.1rem;
  }

  .marT32m {
    margin-top: 0.32rem;
  }

  .marL20m {
    margin-left: 0.2rem;
  }

  /*  *************************************************************************************/


</style>



// WEBPACK FOOTER //
// src/page/association/Association.vue